<template>
  <q-btn
    v-if="!noActivator"
    round
    flat
    size="sm"
    icon="fa-duotone fa-image" class="text-secondary"
    @click.stop="onShow"
  />
  <q-dialog
    ref="dialogRef"
    :model-value="dialogOpenRef"
    no-backdrop-dismiss
    title="Ajouter une image"
    width="600px"
    @hide="onHide"
  >
    <q-uploader
      ref="uploaderRef"
      accept="image/*"
      class="q-mt-md full-width bg-primary"
      color="primary"
      hide-upload-btn
      max-files="1"
      type="file"
      auto-upload
      :factory="files => onUploadFileFactory(files, {publicFile: props.publicFile})"
      @uploaded="onUploaded"
      @failed="uploadFailedRef = true"
      @factory-failed="uploadFailedRef = true"
    >
      <template #header="scope">
        <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
          <q-spinner v-if="scope.isUploading" class="q-uploader__spinner" />
          <div class="col">
            <div class="q-uploader__title">
              Ajouter une image
            </div>
            <div class="q-uploader__subtitle">
              {{ scope.uploadSizeLabel }} / {{ scope.uploadProgressLabel }}
            </div>
          </div>
          <q-btn
            v-if="scope.canAddFiles" type="a" icon="fa-duotone fa-folder-open" round
            dense flat @click="scope.pickFiles"
          >
            <q-uploader-add-trigger />
            <q-tooltip>Ajouter une image</q-tooltip>
          </q-btn>
          <q-btn
            icon="fa-light fa-xmark" round dense
            flat @click="onAbort"
          >
            <q-tooltip>Annuler</q-tooltip>
          </q-btn>
        </div>
      </template>
      <template #list="scope">
        <template v-if="scope.files.length">
          <q-list separator>
            <q-item v-for="file in scope.files" :key="file.__key">
              <q-img :src="file.__img ? file.__img.src : null">
                <div class="absolute-top text-center row">
                  <div class="col text-left">
                    <div>
                      {{ file.name }}
                    </div>
                    <div>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </div>
                  </div>
                  <div class="col-auto">
                    <q-btn
                      class="gt-xs text-red"
                      size="12px"
                      flat
                      dense
                      round
                      icon="fa-light fa-xmark"
                      @click="scope.removeFile(file)"
                    />
                  </div>
                </div>

                <div v-if="uploadFailedRef" class="absolute-bottom text-center row align-center">
                  <div class="col-auto">
                    <q-icon size="xs" name="fa-solid fa-triangle-exclamation" class="text-negative" />
                  </div>
                  <div class="col text-white text-left q-mx-sm">
                    L'image n'a pas pu être envoyé
                  </div>
                  <div class="col-auto">
                    <q-btn size="sm" color="white" outline @click.stop="onRetry">
                      Réessayer
                    </q-btn>
                  </div>
                </div>
              </q-img>
            </q-item>
          </q-list>
        </template>
        <template v-else>
          <div class="q-my-md text-center bg-primary">
            <q-btn color="secondary" size="sm" @click.stop="()=>uploaderRef.pickFiles()">
              Parcourir
            </q-btn>
            <div class="q-my-sm text-white">
              ou faites glisser une image ici
            </div>
          </div>
        </template>
      </template>
    </q-uploader>
  </q-dialog>
</template>

<script setup>
  import { ref, watch } from 'vue'
  import { onUploadFileFactory } from 'src/modules/documents/helpers/fileHelper'

  const props = defineProps({
    modelValue: Boolean,
    noActivator: Boolean,
    // Mark the file as public, all users can see it
    publicFile: Boolean
  })
  const emit = defineEmits(['uploaded', 'update:modelValue'])

  const dialogOpenRef = ref(props.modelValue)
  const uploaderRef = ref(null)
  const dialogRef = ref(null)
  const uploadFailedRef = ref(false)

  watch(() => props.modelValue, newValue => {
    if (dialogOpenRef.value !== newValue) {
      dialogOpenRef.value = newValue
    }
  })

  function onUploaded({ xhr }) {
    emit('uploaded', JSON.parse(xhr.response))
    onHide()
  }

  function onAbort() {
    uploaderRef.value.abort()
    onHide()
  }

  function onRetry() {
    uploadFailedRef.value = false
    uploaderRef.value.upload()
  }

  function onShow() {
    dialogOpenRef.value = true
    emit('update:modelValue', true)
  }

  function onHide() {
    dialogOpenRef.value = false
    emit('update:modelValue', false)
  }
</script>
